export function transformToValidTableColumnName(name: string): string {
  return removeAccents(name.trim()).replace(/\s+/g, "_").toLowerCase();
}

function removeAccents(str: string): string {
  // biome-ignore lint/suspicious/noMisleadingCharacterClass: not sure
  return str.normalize("NFD").replace(/[\u0300-\u036F]/g, "");
}
